import React from 'react'
import { withStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations';
import Button from 'components/Button';

const style = theme => ({
	root: {

	},
	buttonContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
		marginTop: theme.spacing(2)
	}
})

function IEInfo({
	classes,
	open = false,
	onClose,
}) {
	return (
		<Dialog
			title={Tr('attention')}
			open={open}
			onClose={onClose}
		>
			<Typography>
				{Tr('ie_info')}
			</Typography>
			<div className={classes.buttonContainer}>
				<Button
					onClick={onClose}
				>
					{Tr('understand')}
				</Button>
			</div>
		</Dialog>
	)
}

IEInfo.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(IEInfo);